export default {
      id: "i-vtb-usage",
      viewBox: "0 0 56 56",
      url: __webpack_public_path__ + "img/sprite.svg#i-vtb",
      toString: function () {
        return this.url;
      }
    }